export class DateUtil{
    static isValidDate(d: Date) {
        return d instanceof Date && !isNaN(d.getTime());
    }
}